<template>
    <div class="uik-table-actions">
        <UikDropdown
            ref="dropdown"
            v-model="actionsOpen"
            :style="'top: ' + pos.top + 'px; right: ' + pos.right + 'px;'"
            @click.native.prevent
        >
            <UikDropdownItem
                v-for="item in actions"
                :key="item.event"
                :class="{'uik-table-actions__item--active': item.active}"
                @click.native="$emit(item.event); actionsOpen = false"
            >
                <Uikon
                    v-if="item.icon"
                    :icon="item.icon"
                    :class="{'uikon--check': item.icon === 'check'}"
                />
                {{ item.name }}
            </UikDropdownItem>
            <slot/>
        </UikDropdown>
        <UikButton
            ref="openButton"
            icon="more"
            iconOnly
            xs
            transparent
            loaderType="spinner-fade"
            :isLoading="loader"
            @click.native.prevent="open()"
        />
    </div>
</template>

<script>
export default {
    name: "UikTableActions",
    props: {
        /**
         * Is the component in loading state?
         */
        loader: { type: Boolean, default: false },
        /**
         * The dropdown options configuration object
         */
        actions: { type: Array, default: () => [] }
    },
    data () {
        return {
            actionsOpen: false,
            pos: {
                top: "250",
                right: "150"
            }
        }
    },
    methods: {
        /**
         * Opens the table actions and attaches close events to all of them
         */
        open () {
            this.actionsOpen = true
            this.positionDropdown()

            this.$nextTick(() => {
                let actions = this.$refs.dropdown.$el.getElementsByClassName("uik-btn__base")
                for (let i = 0; i < actions.length; i++) {
                    actions[i].onclick = () => { this.actionsOpen = false }
                }
            })
        },
        /**
         * Positions open options on the screen so that they don't overflow
         */
        positionDropdown () {
            let pos = this.$refs.openButton.$el.getBoundingClientRect()
            let screenWidth = window.innerWidth
            let buttonWidth = 27
            this.pos.top = pos.y
            this.pos.right = screenWidth - pos.x - buttonWidth
        }
    }
}
</script>

<style lang="scss">
.uik-table-actions {
      position: relative;
    .uik-menuDrop {
        display: flex;
        justify-content: flex-end;
        align-items: flex-end;
        position: fixed;
        z-index: 999;
        .uik-menuDrop__list {
            display: flex;
            flex-flow: column nowrap;
            justify-content: flex-start;
            align-items: flex-start;
            margin-top: -4px;
            right: auto;
            bottom: auto;
            left: auto;
            top: auto;
            .uik-dropdown-item__wrapper {
                padding: 0 20px 0 15px;
            }
            .uikon, svg {
                margin-right: 8px !important;
            }
            .uikon--check {
                width: 14px;
                font-size: 10.5px;
            }
            .uik-table-actions__item--active {
                background: $bg;
                .uik-btn__content {
                    color: $primary;
                    .uikon {
                        color: $primary;
                    }
                }
            }
        }
    }
    .uik-btn__base.uik-btn__iconOnly {
      padding: 0 7px;
      min-width: unset;
      flex-basis: unset;
      width: 27px;
      background: rgba(white, .15);
      .uik-btn__content {
        transform: rotate(90deg);
        display: flex;
        flex-flow: row nowrap;
        justify-content: center;
        align-items: center;
        .uikon {
          font-size: 12.5px;
          color: rgba($textMain, 0.8);
          font-weight: 600;
          opacity: 1;
        }
      }
      &:hover {
        background: rgba(white, 0.25);
        .uik-btn__content {
          .uikon {
            color: $textMain;
          }
        }
      }
    }
}
</style>
